import React from 'react';
import { Tooltip } from './images/svg/icons';
import GenericTooltip from './generictooltip';
import { useTranslation } from 'react-i18next';

interface RotRutDeductionSectionProps {
    activeTooltipId: string | null;
    setActiveTooltipId: (id: string | null) => void;
    name: string;
    isRutDeductionApplied: boolean,
    isRotDeductionApplied: boolean,
    handleRotRutToggle: (val: boolean, type: 'ROT' | 'RUT') => void;

}

const RotRutDeductionSection: React.FC<RotRutDeductionSectionProps> = ({
    activeTooltipId,
    setActiveTooltipId,
    name,
    isRutDeductionApplied,
    isRotDeductionApplied,
    handleRotRutToggle
}) => {
    const { t } = useTranslation()
    return (
        <>
            <div className="mt-4">
                <span className="font-weight-bold py-4">{t('ROT_AND_RUT_DEDUCTION')}</span>
                <p className='mb-sm-4'>{t('If the job qualifies for home repair allowances, let your client know.')}</p>
                <div className="d-flex align-items-center justify-content-start m">
                    <input
                        className=" custom-checkbox"
                        type="checkbox"
                        checked={isRotDeductionApplied}
                        disabled={isRutDeductionApplied}
                        onChange={() => handleRotRutToggle(!isRotDeductionApplied, 'ROT')}
                    />
                    <p className="px-2 my-0">{t('ROT-DEDUCTION')}</p>
                    <span className="vs-tip-anchor">
                        <img
                            src={Tooltip}
                            className="tooltip-svg cursor-pointer"
                            onClick={() => setActiveTooltipId(name + '-rot')}
                            onMouseEnter={() => setActiveTooltipId(name + '-rot')}
                            onMouseLeave={() => setActiveTooltipId(null)}
                            alt=""
                        />
                        <GenericTooltip
                            isActive={activeTooltipId === name + '-rot'}
                            content={t('ROT_DEDUCTION_FOR_ELIGIBLE_WORK')}
                            onClose={() => setActiveTooltipId(null)}
                            width="w-50"
                            position="left-0"
                            zIndex="z-index-9"
                        />
                    </span>
                </div>
                <div className="d-flex align-items-center justify-content-start my-2">
                    <input
                        className=" custom-checkbox"
                        type="checkbox"
                        checked={isRutDeductionApplied}
                        disabled={isRotDeductionApplied}
                        onChange={() => handleRotRutToggle(!isRutDeductionApplied, 'RUT')}
                    />
                    <p className="px-2 my-0">{t('RUT-DEDUCTION')}</p>
                    <span className="vs-tip-anchor">
                        <img
                            src={Tooltip}
                            className="tooltip-svg cursor-pointer"
                            onClick={() => setActiveTooltipId(name + '-rut')}
                            onMouseEnter={() => setActiveTooltipId(name + '-rut')}
                            onMouseLeave={() => setActiveTooltipId(null)}
                            alt=""
                        />
                        <GenericTooltip
                            isActive={activeTooltipId === name + '-rut'}
                            content={t('RUT_DEDUCTION_FOR_ELIGIBLE_WORK')}
                            onClose={() => setActiveTooltipId(null)}
                            width="w-50"
                            position="left-0"
                            zIndex="z-index-9"
                        />
                    </span>
                </div>
            </div>
        </>
    );
};

export default RotRutDeductionSection;
